// Module
var code = "<div ng-messages=\"form[key].$error\" role=\"alert\">\n  <div ng-messages-include=\"texas-validation-errors.tpl.html\"></div>\n</div>\n";
// Exports
module.exports = code;